import React from "react";
import key_keyless_start from "../../../../assets/images/keyless-return/keyless_start.svg";
import key_error from "../../../../assets/images/keyless-return/error.svg";
import key_guerin_logo from "../../../../assets/images/keyless-return/guerin_logo.svg";
import { KeylessReturnFooter } from "../components/KeylessReturnFooter";
import { KeylessButton } from "../../components/KeylessButton";
import { KeylessModal } from "../../components/KeylessModal";

export default function Start({
  contractNumber,
  t,
  localizationAssets,
  onStart,
  helpModalOpen,
  setHelpModalOpen,
  currentLang,
  onLanguageChange,
  languages,
}) {
  const otherLangs = (languages || []).filter((l) => l.id !== currentLang);
  const nextLang = otherLangs.length > 0 ? otherLangs[0] : null;

  return (
    <div style={styles.page}>
      {nextLang && (
        <button
          style={styles.langButton}
          onClick={() => onLanguageChange(nextLang.id)}
        >
          <img
            src={nextLang.imageUrl}
            alt={nextLang.label}
            style={styles.langFlag}
          />
        </button>
      )}

      <img src={key_guerin_logo} alt="Guerin" style={styles.logo} />

      <img src={key_keyless_start} alt="Key Return" style={styles.hero} />

      <div style={styles.bottom}>
        <KeylessReturnFooter
          primaryText={t("keylessReturnStart")}
          primaryOnClick={onStart}
          showSecondary={false}
        />

        <div style={styles.warning}>
          <img src={key_error} alt="" style={styles.warningIcon} />
          <p style={styles.warningText}>
            {t("keylessReturnKeepKey")}
          </p>
        </div>
      </div>

      <div style={styles.reservationLine}>
        <div style={{ opacity: contractNumber ? 1 : 0 }}>{contractNumber}</div>
        <div
          style={styles.reservationLineHelp}
          onClick={() => setHelpModalOpen(true)}
        >
          <div>{t("keylessReservationHelp")}</div>
          <img
            src={localizationAssets["keylessReservationHelp"]}
            style={styles.reservationLineHelpImg}
            alt=""
          />
        </div>
      </div>
      <KeylessModal
        isOpen={helpModalOpen}
        title={t("keylessHelpTitle")}
        message={t("keylessHelpMessage")}
        animation="slide-up"
        img={localizationAssets["keylessReservationHelp"]}
        imgStyle={{ height: "35px", width: "35px" }}
        modalStyle={{ minHeight: "350px" }}
        actions={
          <KeylessButton
            text={t("keylessHelpClose")}
            onClick={() => setHelpModalOpen(false)}
          />
        }
      />
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100dvh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#FFFFFF",
    fontFamily: "'BlissLight'",
    textAlign: "center",
    boxSizing: "border-box",
    gap: "1.5rem",
    paddingTop: "1rem",
    position: "relative",
  },
  langButton: {
    position: "absolute",
    top: "1rem",
    right: "1.5rem",
    width: "40px",
    height: "40px",
    padding: 0,
    border: "1px solid #E0E0E0",
    borderRadius: "50%",
    backgroundColor: "#FFFFFF",
    cursor: "pointer",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  langFlag: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  logo: {
    width: "60%",
    maxWidth: "260px",
    height: "auto",
    marginTop: "2rem",
  },
  hero: {
    maxWidth: "80%",
    height: "auto",
  },
  bottom: {
    width: "100%",
    padding: "2rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "1rem",
  },
  warning: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "0.5rem",
  },
  warningIcon: {
    height: "20px",
    width: "20px",
  },
  warningText: {
    fontSize: "1rem",
    margin: 0,
    fontWeight: 600,
    color: "#303030",
  },
  reservationLine: {
    backgroundColor: "#F0F0F0",
    padding: "12px 15px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    height: "15vh",
  },
  reservationLineHelp: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    color: "#FD812A",
  },
  reservationLineHelpImg: {
    height: "25px",
  },
};
